import React from 'react';

export const PopoverContext = React.createContext<{ closePopover(): void }>({ closePopover() {} });
